import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { environment } from '../utils/Environment'
import { Reservation,CheckIn, UpdateCheckInResponse, UpdateCheckInForm, FicheHebergement } from '../utils/Interface'
import qs from 'qs'
import { RootState } from '../store/GlobalStore'
import { StringLiteral } from 'typescript'
const ReservationAPI = createApi({
    reducerPath: 'ReservationAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: `${environment.api_url as string}reservation`,
        prepareHeaders: (headers, { getState }) => {
            //headers.set('Content-Type', 'application/json')
            const token = (getState() as RootState).Auth.jwt
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        }
    }),

    endpoints: (build) => ({
        getUserReservation: build.query<Reservation, string>({
            query: (email) => `/findOne/${email}`
        }),
        getCheckInForm: build.query<CheckIn, string>({
            query: (ressource) => `/findCheckIn/${ressource}`
        }),
        getCheckOutForm: build.query<CheckIn, string>({
            query: (ressource) => `/findCheckOut/${ressource}`
        }),
        updateCheckIn: build.mutation<UpdateCheckInResponse, UpdateCheckInForm>({
            query: (data: UpdateCheckInForm) => ({
                url: '/updateCheckIn',
                method: 'POST',
                body: data
            })
        }),
        updateCheckOut: build.mutation<UpdateCheckInResponse, UpdateCheckInForm>({
            query: (data: UpdateCheckInForm) => ({
                url: '/updateCheckOut',
                method: 'POST',
                body: data
            })
        }),
        getFicheHebergement: build.query<FicheHebergement, string>({
            query: (ressourceTypeCode) => `/getFicheHebergement/${ressourceTypeCode}`
        })
    })
})

export default ReservationAPI
export const {
    useGetUserReservationQuery,
    useGetCheckInFormQuery,
    useGetCheckOutFormQuery,
    useUpdateCheckInMutation,
    useUpdateCheckOutMutation,
    useGetFicheHebergementQuery
} = ReservationAPI
